<template>
  <b-container>
    <h1>
      Shopping Cart
      <span v-if="cart.cost > 0">(${{ cart.cost }})</span>
    </h1>
    <div class="jumbotron">
      <p class="mx-auto" v-if="cart.courses.length < 1">
        <strong
          >You haven’t added any courses. Please add at least one course to
          continue.</strong
        >
      </p>
      <div v-for="(course, index) in courses" :key="index">
        <Course :course="course"></Course>

        <b-row>
          <b-col>
            <b-button
              variant="danger"
              sm="lg"
              class="text-center"
              @click="removeFromCart(index)"
              >Remove</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <hr />
          </b-col>
        </b-row>
      </div>

      <b-row class="mt-4">
        <b-col md="4">
          <router-link to="/">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
              >Add Course(s)</b-button
            >
          </router-link>
        </b-col>

        <b-col md="4" v-if="courses.length > 0">
          <router-link to="/biodemo">
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
              >Proceed to Student Information</b-button
            >
          </router-link>
        </b-col>

        <b-col md="4">
          <router-link
            to="/complete"
            v-if="bioDemoSubmitted && this.courses.length > 0"
          >
            <b-button
              block
              variant="danger"
              class="d-block mt-2"
              size="block"
              type="submit"
              >Review</b-button
            >
          </router-link>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mixins } from "../mixins";
import Course from "../components/course";

export default {
  name: "cart",
  components: {
    Course,
  },
  data() {
    return {
      cart: {},
      courses: [],
      bioDemoSubmitted: false,
    };
  },
  mixins: [mixins],
  created() {
    this.getCart();
  },
  methods: {
    setReview() {
      this.bioDemoSubmitted = this.$store.getters.bioDemoSubmitted;
    },
    getCart() {
      this.api
        .post("/cart", {
          cartId: this.$store.getters.cartId,
        })
        .then((response) => {
          this.cart = response.data;
          this.courses = response.data.courses;
          this.setReview();
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    removeFromCart(index) {
      let rec = this.cart.courses[index];
      this.api
        .post("/removeFromCart", {
          term: rec.term,
          crn: rec.crn,
          cartId: this.$store.getters.cartId,
        })
        .then(async () => {
          await this.getCart();
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
  },
};
</script>

<style scoped></style>
